import { useState, useCallback, useEffect, ChangeEvent, FormEvent } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from 'core/use-cases/catalog';
import { RootState, utilities } from 'core';
import { AVAILABLE_OPTION } from 'core/domains/catalog.d';
import { useDispatch } from 'react-redux';

export const useHeaderSearch = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const [focus, toggleFocus] = useState(false);

  const statusPreview = useSelector((state: RootState) => state.catalog.statusPreview);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.currentTarget;
    setSearchValue(inputValue);
  }, []);

  const handleOnChangeCallback = useCallback(
    utilities.debounce((inputValue: string) => {
      const queryOptions = {
        itemsPerPage: Number(16),
        query: inputValue,
        availability: AVAILABLE_OPTION.first,
      };
      dispatch(actions.searchPreviousFetch.request(queryOptions));
      toggleFocus(true);
    }),
    [],
  );

  useEffect(() => {
    if (searchValue.length > 2) {
      handleOnChangeCallback(searchValue);
    }
  }, [searchValue, handleOnChangeCallback]);

  const handleFocus = (e: any) => {
    return toggleFocus(!focus);
  };

  const handleFocusOverlay = (e: any) => {
    setSearchValue('');
    return toggleFocus(false);
  };

  const handleSearchClick = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (searchValue.length > 2) {
      utilities.debounce(() => {
        dispatch(actions.searchEnter(searchValue));
        history.push(`/pesquisa?q=${searchValue}`);
        handleClearSearch();
        toggleFocus(false);
      })();
    }
  };

  const handleClearSearch = () => {
    setSearchValue('');
    toggleFocus(false);
  };

  return {
    searchValue,
    handleChange,
    focus,
    handleFocus,
    handleFocusOverlay,
    handleSearchClick,
    handleClearSearch,
    statusPreview,
  };
};
